module.exports = __webpack_public_path__ + "static/media/administration.4c8614c8.svg";